import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { consumirServicioEncirptacion } from '../../api';
import BreadCurmb from '../../components/BreadCrumbMex/BreadCrumb';
import { SimpleWrapper } from '../../components/InputsMex/containers';
import { TextInput } from '../../components/InputsMex/inputs';
import { emailRegex } from '../../components/InputsMex/validaciones';
import Page from '../../components/Page';
import {
  ambienteAplicacion,
  urlRecuperarContraseniaMex,
} from '../../constants/urls';
import Loading from '../../wrappers/Loading';

const RecuperarContraseniaContainer = ({
  loading,
  setLoading,
  addToast,
  history,
}) => {
  const methods = useForm({ mode: 'onChange' });

  const onSubmit = async (data) => {
    setLoading(true);

    const Data = {
      cliEmail: data.correo,
      ambiente: ambienteAplicacion,
      from: 'front',
    };

    const result = await consumirServicioEncirptacion(
      urlRecuperarContraseniaMex,
      Data,
    );

    if (result && result.transaccion) {
      addToast(result.mensaje, {
        appearance: 'success',
      });
      history.push('/');
    } else {
      addToast(result.mensaje, {
        appearance: 'warning',
      });
    }
    setLoading(false);
  };

  return (
    <Loading loading={loading}>
      <div className="cr-content">
        <Page>
          <BreadCurmb title="Recuperar Contraseña" subtitle="Recuperar Contraseña" />

          <div className="row justify-content-center mb-5">
            <div className="col-sm-9 col-md-6 col-lg-5 ">
              <div className="card-login-mex">
                <div className="card-login-mex-title">
                  <h2 className="font-mex">Recuperar Contraseña</h2>
                  <p
                    className="font-source-sans-regular"
                    style={{ fontSize: '14px' }}
                  >
                    Por favor ingresa tu correo electrónico y revisa tu bandeja de
                    entrada
                  </p>
                </div>
                <div className="card-login-mex-frm">
                  <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(onSubmit)}>
                      <SimpleWrapper name="correo" label="Correo Electrónico">
                        <TextInput
                          inputProps={{
                            name: 'correo',
                            placeholder: 'jperez@email.com',
                          }}
                          rules={{
                            required: 'Este campo es obligatorio',
                            pattern: {
                              value: emailRegex,
                              message: 'Ingresa un email correcto',
                            },
                          }}
                        />
                      </SimpleWrapper>

                      <div className="form-row justify-content-center mt-4">
                        <div className="col-10 col-md-8 ">
                          <button
                            className="btn btn-login-mex btn-block"
                            type="submit"
                          >
                            Enviar Correo
                          </button>
                        </div>

                        <div className="col-10 col-md-8 text-center mt-3">
                          <Link to={`/login`} className="regresar-login ">
                            Regresar
                          </Link>
                        </div>
                      </div>
                    </form>
                  </FormProvider>
                </div>
              </div>
            </div>
          </div>
        </Page>
      </div>
    </Loading>
  );
};

export default RecuperarContraseniaContainer;
